import { configureStore } from '@reduxjs/toolkit';

import rootReducer from './reducers';
import api from './services/api';
import iqApi from './services/api/iqApi';

const store = configureStore({
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware, iqApi.middleware),
  reducer: rootReducer,
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export enum HttpRequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}
export enum HttpHeaders {
  ACCEPT = 'Accept',
  CONTENT_TYPE = 'Content-Type',
}
export enum ContentTypes {
  FORM_URL_ENCODED = 'application/x-www-form-urlencoded',
  JSON = 'application/json',
  TEXT = 'text/plain',
}
